import { render } from "./KeywordSearch.vue?vue&type=template&id=0bce21d8&scoped=true&ts=true"
import script from "./KeywordSearch.vue?vue&type=script&lang=ts"
export * from "./KeywordSearch.vue?vue&type=script&lang=ts"

import "./KeywordSearch.vue?vue&type=style&index=0&id=0bce21d8&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bce21d8"]])

export default __exports__